import React, { useEffect, useMemo, useState } from "react";
import ApiData from "../../../api/ApiData";
import { ListClientIdAdmin } from "./ListClientIdAdmin";
import { observer } from "mobx-react-lite";
import { ModalWaringClientID } from "./ModalWaringClientID";
import FilterData from "../../../api/FilterData";
import Loader from "../../Loader";

export const ClientIdAdmin = observer(() => {
  useEffect(() => {
    ApiData.getAllSoft();
  }, []);

  const [modalWaringFlag, setModalWaringFlag] = useState(false);
  const [clientID, setClientID] = useState(null);
  const [idSearch, setIdSearch] = useState("");

  const deleteClient = (e) => {
    setModalWaringFlag(true);
    setClientID(e);
  };

  useMemo(() => {
    FilterData.searchIdClientAllSoft(idSearch);
  }, [idSearch]);

  const gridClass = "cc-v4-soft-grid admin-client-id-grid";

  return (
    <section
      className="card cc-v4-soft-list-root admin-panel-section"
      aria-label="Клиенты ИД"
    >
      <div className={`cc-v4-soft-header ${gridClass}`}>
        <label className="search_id_client_container cc-v4-soft-th-id admin-client-id-search">
          <span className="cc-v4-soft-th-label">ИД клиента</span>
          <input
            type="search"
            className="search_id_client cc-v4-soft-id-input"
            placeholder="Поиск по id clients"
            onChange={(e) => setIdSearch(e.target.value)}
            value={idSearch}
            aria-label="Поиск по id clients"
          />
        </label>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">Название</span>
        </span>
        <span className="cc-v4-soft-th-static">
          <span className="cc-v4-soft-th-label">Компания</span>
        </span>
        <span className="cc-v4-soft-th-static admin-client-id-th-action">
          <span className="cc-v4-soft-th-label">Отвязать</span>
        </span>
      </div>

      {ApiData.soft_all.length ? (
        <div className="cc-v4-soft-body">
          <ListClientIdAdmin deleteClient={deleteClient} gridClass={gridClass} />
        </div>
      ) : (
        <Loader />
      )}

      {modalWaringFlag ? (
        <ModalWaringClientID
          clientID={clientID}
          setModalWaringFlag={setModalWaringFlag}
        />
      ) : null}
    </section>
  );
});
